import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error(
    'Missing VITE_SUPABASE_URL environment variable. ' +
      'Copy .env.example to .env and fill in your Supabase project URL. ' +
      'Find it at: Supabase Dashboard → Settings → API.',
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_ANON_KEY environment variable. ' +
      'Copy .env.example to .env and fill in your Supabase anon key. ' +
      'Find it at: Supabase Dashboard → Settings → API.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// ---------------------------------------------------------------------------
// Analytics: track sign-up activation milestone (fire-and-forget)
// ---------------------------------------------------------------------------
import { trackEvent } from '@/lib/analytics';

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN' && session?.user) {
    try {
      if (!localStorage.getItem('synter_signed_up')) {
        const method = session.user.app_metadata?.provider ?? 'email';
        trackEvent('sign_up', { method });
        localStorage.setItem('synter_signed_up', '1');
      }
    } catch {
      // localStorage or analytics unavailable — ignore
    }
  }
});
